import { ImageData } from "~/interface/commonImagesize-types";

export const RECENT_SEARCHES_KEY = "recentSearches";
export const SEARCH_STR = "search-str";

export interface MenuItem {
  id: string | number;
  name: string;
  desc: string;
  image?: ImageData;
  icon?: string;
  url?: string;
  type: string;
}

export interface RecentSearch {
  query: string;
  url: string;
  image: string;
  name: string;
  module: string;
}
export interface SearchListItemProps {
  image: string;
  title: string;
  subtitle?: string;
  isActive: boolean;
  onClick: () => void;
  onClose?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

// handle set recent search in local storage
export const setLocalStorageRecentSearch = (search_data: RecentSearch) => {
  const recentSearches: RecentSearch[] = JSON.parse(localStorage.getItem(RECENT_SEARCHES_KEY) || "[]");
  const hasExactMatch = recentSearches.some((item) => item.query === search_data.query && item.url === search_data.url);

  if (!hasExactMatch) {
    recentSearches.push(search_data);
    localStorage.setItem(RECENT_SEARCHES_KEY, JSON.stringify(recentSearches));
  }
};
// get recent searches from local storage
export const getRecentSearch = () => {
  if (typeof window !== "undefined" && typeof localStorage !== "undefined") {
    const recentSearches = localStorage.getItem(RECENT_SEARCHES_KEY);
    if (recentSearches) {
      const searches = JSON.parse(recentSearches).reverse();
      return searches.slice(0, 10);
    }
  }
  return [];
};

export const getSearchStrFromLocalStorage = () => {
  if (typeof window !== "undefined" && typeof sessionStorage !== "undefined") {
    const searchStr = sessionStorage.getItem(SEARCH_STR);
    return searchStr ? searchStr : "";
  }
  return "";
};

export const setSearchStrToLocalStorage = (searchStr: string) => {
  sessionStorage.setItem(SEARCH_STR, searchStr || "");
};
